import { RouterView, type RouteRecordRaw } from "vue-router";

export const commerceRoutes: RouteRecordRaw[] = [
  {
    path: "customers-commerce",
    name: "customers_commerce",
    redirect: { name: "commerce_ecom" },
    meta: {
      activityArea: "ecommerce",
      title: "Commerce",
      text: "Commerce",
      description:
        "Track e-commerce activity and revenue across your storefront",
      icon: "shopping-cart",
      added: "2026-05-22",
      breadcrumb: {
        label: "Commerce",
        to: { name: "commerce_ecom" },
      },
    },
    component: () =>
      import("@/views/CustomersCommerce/CustomersCommerceBase.vue"),
    children: [
      {
        path: "ecommerce",
        name: "commerce_ecom",
        meta: { title: "Overview", breadcrumb: false },
        component: () => import("@/views/ECommerce/ECommerceReport.vue"),
      },
      {
        path: "stores",
        name: "commerce_stores_shell",
        redirect: { name: "commerce_stores" },
        meta: {
          title: "Stores",
          text: "Stores",
          beta: true,
          breadcrumb: {
            label: "Stores",
            to: { name: "commerce_stores" },
          },
          // No requiredFeatureFlag: the tab is visible to everyone; StoresGate
          // renders the paywall for orgs without the crm flag.
        },
        component: RouterView,
        children: [
          {
            path: "",
            name: "commerce_stores",
            meta: {
              title: "Stores",
              breadcrumb: false,
              // StoresGate pitches CRM in place; declared so readers of
              // route meta (activity tracking) know the page is gated.
              requiredFeatureFlag: "crm",
              paywall: "in-component",
            },
            component: () => import("@/views/CustomersCommerce/StoresGate.vue"),
          },
          {
            path: ":id",
            name: "commerce_store_detail",
            meta: {
              title: "Store details",
              excludeFromNavbar: true,
              requiredFeatureFlag: "crm",
              breadcrumb: {
                label: "Store",
                dynamic: true,
                fallback: "Store",
              },
            },
            component: () =>
              import("@/views/CustomersCommerce/StoreDrilldown.vue"),
          },
        ],
      },
    ],
  },
];
